import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { MembershipPlansComponent } from "src/app/admin-panel/components/business/membership-plans/membership-plans.component";
import { PaymentProcessorsComponent } from "src/app/admin-panel/components/business/payment-processors/payment-processors.component";
import { PaymentsComponent } from "src/app/admin-panel/components/business/payments/payments.component";
import { AppUsersComponent } from "src/app/admin-panel/components/members/app-users/app-users.component";
import { MemberCompaniesComponent } from "src/app/admin-panel/components/members/member-companies/member-companies.component";
import { GeneralManagerComponent } from "src/app/admin-panel/components/system-profiles/general-manager/general-manager.component";
import { MyProfileComponent } from "src/app/admin-panel/components/system-profiles/my-profile/my-profile.component";
import { SuperAdministratorComponent } from "src/app/admin-panel/components/system-profiles/super-administrator/super-administrator.component";
import { TechSupportComponent } from "src/app/admin-panel/components/system-profiles/tech-support/tech-support.component";
import { PageNotFoundComponent } from "src/app/components/page-not-found/page-not-found.component";
import { IsAuthenticatedGuard } from "src/app/_guards/is-authenticated.guard";

const routes: Routes = [


    { path: 'admin/my-profile', component: MyProfileComponent, canActivate: [IsAuthenticatedGuard] },
    { path: 'admin/general-manager', component: GeneralManagerComponent, canActivate: [IsAuthenticatedGuard] },
    { path: 'admin/super-administrators', component: SuperAdministratorComponent, canActivate: [IsAuthenticatedGuard] },
    { path: 'admin/tech-support', component: TechSupportComponent, canActivate: [IsAuthenticatedGuard] },
    { path: 'admin/membership-plans', component: MembershipPlansComponent, canActivate: [IsAuthenticatedGuard] },
    { path: 'admin/payment-processors', component: PaymentProcessorsComponent, canActivate: [IsAuthenticatedGuard] },
    { path: 'admin/payments',component:PaymentsComponent,canActivate:[IsAuthenticatedGuard]},
    { path: 'admin/member-companies',component:MemberCompaniesComponent,canActivate:[IsAuthenticatedGuard]},
    { path: 'admin/app-users',component:AppUsersComponent,canActivate:[IsAuthenticatedGuard]},
    { path: 'admin', redirectTo: 'admin/my-profile', pathMatch: 'full'},
    { path: '', redirectTo: 'admin/my-profile', pathMatch: 'full'},
    { path: 'page-not-found', component: PageNotFoundComponent, canActivate: [IsAuthenticatedGuard] },
    { path: '**', redirectTo: '/page-not-found' }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class AdminRoutingModule { }